const systemMain = {
  title: 'СИСТЕМА, ЯКА ПРАЦЮЄ У БОЮ',
  description:
    'Ми реалізуємо повний цикл впровадження БпАК – від розробки та інтеграції у тактичні завдання до підготовки операторів і техпідтримки 24/7 – для забезпечення стабільності на полі бою.',
  cards: {
    education: {
      title: 'НАВЧАННЯ ОПЕРАТОРІВ',
      description:
        'Повний курс підготовки з відпрацюванням реальних бойових сценаріїв.',
    },
    bpla: {
      title: 'Бпла',
      description:
        'Ударний БпЛА, що діє в умовах активного РЕБ і за відсутності GPS.',
    },
    bpak: {
      title: 'БпаК',
      description:
        'Комплекс для високоточного ураження цілей у тактичній глибині, стійкий до РЕБ.',
    },
  },
}

export default systemMain
